export const buildNumber = '20260831.7';
export const version = 'main';
export const latestCommit = '477df93ade0a1232ed19af2cdd8e15cf2126cd65';
